import { db } from '../services/firebase';

export const clientStore = {

	state: {
		clients: []
	},

	init() {
		return new Promise((resolve, reject) => {
			db.collection('clients')
				.orderBy('name')
				.onSnapshot((data) => {
					this.state.clients = data.docs.map((doc) => {
						return Object.assign({}, doc.data(), { id: doc.id });
					});

					resolve();
				}, (error) => {
					reject(error);
				});
		});
	},

	destroy() {
		db.collection('clients').onSnapshot(() => {})();
	},

	get(id) {
		return this.state.clients.find(c => c.id === id);
	},

	save(client) {
		return db.collection('clients').add(client);
	},

	update(id, data) {
		return db.collection('clients').doc(id).update(data);
	},

	delete(id) {
		db.collection('clients').doc(id).delete();
	},

	createEmpty() {
		return {
			id: null,
			name: '',
			address: '',
			taxNumber: '',
			registrationNumber: ''
		};
	}

};



// WEBPACK FOOTER //
// ./src/stores/clients.js